import { createUseFilteredEntitiesInfinite } from "@/services/api/infinite";
import { CompanyContractRow } from "./types";

const COMPANY_CONTRACTS_PAGE_SIZE = 50;

const useNoopCompanyContractsStore = () => ({ addEntity: () => {} });

const { useFilteredEntitiesInfinite: useFilteredCompanyContractsInfinite } =
  createUseFilteredEntitiesInfinite<CompanyContractRow>(
    "companyContracts",
    COMPANY_CONTRACTS_PAGE_SIZE,
    {
      responseKey: "contracts",
      extraQueryParams: { status_group: "active" }
    }
  );

export const useActiveCompanyContracts = (companyId: string | undefined) => {
  const result = useFilteredCompanyContractsInfinite(
    useNoopCompanyContractsStore,
    { fetchAll: true, enabled: !!companyId },
    undefined,
    companyId
  );

  return {
    contracts: result.entities,
    isLoading: result.isLoading,
    error: result.isError ? result.error : null
  };
};
